export enum WoundCareConstants {
  SET_ACTIONS = 'woundCare/SET_ACTIONS',
  SET_SITE = 'woundCare/SET_SITE',
  SET_SIZE = 'woundCare/SET_SIZE',
  SET_RESPONSE = 'woundCare/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'woundCare/SET_RESPONSE_PNNV',
  SAVE_WOUND_CARE = 'woundCare/SAVE_WOUND_CARE',
  RESET_STATE = 'woundCare/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'woundCare/SET_ADD_TO_TIMELINE',
  SET_STATE = 'woundCare/SET_STATE',
  SET_DATE_TIME = 'woundCare/SET_DATE_TIME',
  SET_PTA = 'woundCare/SET_PTA',
  SET_ASSESSED_BY = 'woundCare/SET_ASSESSED_BY',
  ON_SELECT_WOUND_CARE = 'woundCare/ON_SELECT_WOUND_CARE',
  SET_UPDATE_INPUT_ROWS = 'woundCare/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'woundCare/SET_DATE',
  SET_TIME = 'woundCare/SET_TIME',
  SET_ATTEMPTS = 'woundCare/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'woundCare/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'woundCare/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'woundCare/SET_SUCCESSFUL_ATTEMPT',
  SET_COMMENTS = 'woundCare/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'woundCare/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'woundCare/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'woundCare/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'woundCare/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
}
